<template>
    <v-app>
        <v-container>
            <v-row>
                <h3>View users</h3>
            </v-row>
            <v-row class="mt-5">
                <v-btn color="default" @click="$router.push('/user/create')">Agregar Usuario</v-btn>
            </v-row>
            <v-row class="mt-5 bold">
            <v-col lg="2">
                ID
            </v-col>
            <v-col lg="2">
                Nombre
            </v-col>
            <v-col lg="2">
                Email
            </v-col>
            <v-col lg="2">
                ...
            </v-col>
            </v-row>
            <v-row  v-for="user in users" :key="user.id">
                <v-col lg="2">{{user.id}}</v-col>
                <v-col lg="2">{{user.name}}</v-col>
                <v-col lg="2">{{user.mail}}</v-col>
                <v-col lg="2">
                    <v-btn color="info" @click="$router.push(`/user/${user.id}`)">Ver</v-btn>
                </v-col>
            </v-row>
        </v-container>
        
    </v-app>
</template>

<script>
import axios from 'axios'
import router from '../../router/index.js'

export default {
    data(){
        return {
            users: []
        }
    },
    methods: {
        getData: async function(){
            let {data} = await axios.get('https://127.0.0.1:3000/user/')
            this.users=data
        }
    },
    mounted(){
        //Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;

        axios.interceptors.response.use(function (response){
            //console.log(response.data.message);
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        });
        //End config for axios
        this.getData()
    }
}
</script>

<style>
    .bold{
        font-weight: bolder
    }
</style>